import { z } from 'zod';

import { PropertyId } from '../../../BrandedIds';
import { OptionalPhoneNumber } from '../../../Phone';
import { OptionalEmailString } from '../../email';
import { AddressLine, Checkbox, DateString, NonNegativeMonetaryValue } from '../../fields';

const SingleInsuranceFields = z.object({
  isEscrowed: Checkbox.optional(),
  amount: NonNegativeMonetaryValue.optional(),
  coverageAmount: NonNegativeMonetaryValue.optional(),
  agentName: z.string().optional(),
  agentEmail: OptionalEmailString,
  agentPhone: OptionalPhoneNumber,
  payeeId: z.string().optional(),
  companyName: z.string().optional(),
  companyAddressLine1: AddressLine.optional(),
  companyAddressLine2: AddressLine.optional(),
  companyAddressCity: z.string().optional(),
  companyAddressState: z.string().optional(),
  companyAddressZip: z.string().optional(),
  policyNumber: z.string().optional(),
  policyStart: DateString.optional(),
  policyEnd: DateString.optional(),
  forcedPlacedFlag: Checkbox.optional(),
});

const SinglePropertyInsuranceFields = z.object({
  hazard: SingleInsuranceFields.optional(),
  homeowners: SingleInsuranceFields.optional(),
  flood: SingleInsuranceFields.optional(),
  windstorm: SingleInsuranceFields.optional(),
  hurricane: SingleInsuranceFields.optional(),
  fire: SingleInsuranceFields.optional(),
  liability: SingleInsuranceFields.optional(),
  rental: SingleInsuranceFields.optional(),
  condo: SingleInsuranceFields.optional(),
  earthquake: SingleInsuranceFields.optional(),
  umbrella: SingleInsuranceFields.optional(),
  sinkhole: SingleInsuranceFields.optional(),
  wildfire: SingleInsuranceFields.optional(),
  sewer: SingleInsuranceFields.optional(),
  equipment: SingleInsuranceFields.optional(),
  title: SingleInsuranceFields.optional(),
  other: SingleInsuranceFields.optional(),
});

export const PrimaryPropertyInsuranceFields = z.object({
  address1Insurance: SinglePropertyInsuranceFields.optional(),
});

const MultiSinglePropertyInsuranceFields = SinglePropertyInsuranceFields.extend({
  propertyId: PropertyId.optional(),
});

export const MultiPropertyInsuranceFields = z.object({
  address2Insurance: MultiSinglePropertyInsuranceFields.optional(),
  address3Insurance: MultiSinglePropertyInsuranceFields.optional(),
  address4Insurance: MultiSinglePropertyInsuranceFields.optional(),
  address5Insurance: MultiSinglePropertyInsuranceFields.optional(),
  address6Insurance: MultiSinglePropertyInsuranceFields.optional(),
  address7Insurance: MultiSinglePropertyInsuranceFields.optional(),
  address8Insurance: MultiSinglePropertyInsuranceFields.optional(),
  address9Insurance: MultiSinglePropertyInsuranceFields.optional(),
  address10Insurance: MultiSinglePropertyInsuranceFields.optional(),
  address11Insurance: MultiSinglePropertyInsuranceFields.optional(),
  address12Insurance: MultiSinglePropertyInsuranceFields.optional(),
  address13Insurance: MultiSinglePropertyInsuranceFields.optional(),
  address14Insurance: MultiSinglePropertyInsuranceFields.optional(),
  address15Insurance: MultiSinglePropertyInsuranceFields.optional(),
});
